Hideaways.scheduledNotice = function () {
    var notice = new ScheduledNotice();
    notice.init();

    Hideaways._notice = notice;
}
